import { render, staticRenderFns } from "./VerificationSchool.vue?vue&type=template&id=ae0fcb2a&scoped=true"
import script from "./VerificationSchool.vue?vue&type=script&lang=ts"
export * from "./VerificationSchool.vue?vue&type=script&lang=ts"
import style0 from "./VerificationSchool.vue?vue&type=style&index=0&id=ae0fcb2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0fcb2a",
  null
  
)

export default component.exports